import { render, staticRenderFns } from "./meetingRoomSetup.vue?vue&type=template&id=482811e3&scoped=true&"
import script from "./meetingRoomSetup.vue?vue&type=script&lang=js&"
export * from "./meetingRoomSetup.vue?vue&type=script&lang=js&"
import style0 from "./meetingRoomSetup.vue?vue&type=style&index=0&id=482811e3&prod&lang=scss&scoped=true&"
import style1 from "./meetingRoomSetup.vue?vue&type=style&index=1&id=482811e3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482811e3",
  null
  
)

export default component.exports